import { Injectable } from "@angular/core";
import { CollectionConfig } from "akita-ng-fire";
import { FirebaseService } from "../firebase.service";
import { extractCompanyId, Role } from "./role.model";
import { RoleState, RoleStore } from "./role.store";
import { collection, deleteDoc, doc, getDocs, query, where } from "@angular/fire/firestore";

@Injectable({ providedIn: "root" })
@CollectionConfig({ path: "roles" })
export class RoleService extends FirebaseService<RoleState> {
  constructor(store: RoleStore) {
    super(store);
  }

  protected preFormat<E extends Role>(role: Readonly<Partial<E>>): E {
    return {
      ...role,
      company: doc(this.db, "companies", extractCompanyId(role))
    } as unknown as E;
  }

  async deleteIfUnused(roleId: string): Promise<void> {
    const products = await getDocs(query(collection(this.db, "products"), where("roles", "array-contains", roleId)));
    const users = await getDocs(
      query(collection(this.db, "users"), where("companyRole", "==", doc(this.db, "roles", roleId)))
    );

    if (products.size || users.size) {
      throw Object.assign(new Error("Role is still in use"), { products: products.size, users: users.size });
    }

    await deleteDoc(doc(this.db, "roles", roleId));
    this.store.remove(roleId as any);
  }
}
